export default {
  title: `Provider's data`,
  contractReferenceTooltip: 'To Bankia/Caixa, the contract reference is mandatory. The field only admits a T and a maximum of 7 digits (Ex: T1234567)',
  contractReferenceTooltipEurobits: 'Only when emitting invoices to Bankia/Caixa. The contract reference is mandatory. The field only admits a T and a maximum of 7 digits (Ex: T1234567)',
  invalidData: 'Registered provider data are not correct. You must update them in "General data" and "Agenda"'
}
